import { cn } from '@/components/ui/cn';

export interface SpinnerProps {
  label?: string;
  className?: string;
}

export function Spinner({ label, className }: SpinnerProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-500" role="status" aria-live="polite">
      <span
        className={cn(
          'inline-block h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-brand-600',
          className,
        )}
      />
      {label && <span>{label}</span>}
    </div>
  );
}
